import React, { Component } from 'react';

import { injectIntl } from 'react-intl';

import defaultIcon from 'assets/images/default-icon-placeholder-100.png';
import searchNotFound from 'assets/images/search_not_found.svg';

import config from './StaticAccordion.component.config';
import text from './StaticAccordion.translation';
import './StaticAccordion.less';
export class StaticAccordion extends Component {
  navigateTo = (billerID, status) => () => {
    if (status === 'active') {
      this.props.itemClick(billerID);
    }
  };

  statusTableCase = status => {
    switch (parseInt(status, 10)) {
      case 2:
        return 'active';
      case 1:
        return 'in-active';
      default:
        return 'hidden';
    }
  };

  statusReader = data => {
    if (window.IS_IN_PLAYGROUND) {
      return this.statusTableCase(data.status.pground_status);
    }
    if (window.IS_IN_SKYWALKER) {
      return this.statusTableCase(data.status.skyw_status);
    }
    return this.statusTableCase(data.status.pground_status);
  };
  removeHidden = data => {
    const finalData = [];
    for (let i = 0; i < data.length; i += 1) {
      if (this.statusReader(data[i]) !== 'hidden') {
        finalData.push(data[i]);
      }
    }
    return finalData;
  };
  render() {
    const {
      intl: { formatMessage },
    } = this.props;
    const { data } = this.props;
    const keys = Object.keys(data);
    const accordionItem = [];

    for (let i = 0; i < keys.length; i += 1) {
      const itemKey = keys[i];
      const item = this.removeHidden(data[itemKey]);
      const listAirline = [];
      for (let j = 0; j < item.length; j += 1) {
        const biller = item[j];
        const buildAirline = (
          <div
            id={`list_bank_${biller.id}`}
            className={`item-list ${this.statusReader(biller)}`}
            key={biller.id}
            onClick={this.navigateTo(biller.id, this.statusReader(biller))}
          >
            <div className="icon">
              <img src={biller.icon || defaultIcon} alt={biller.name} />
            </div>
            <div className="list-name">
              <p>{biller.name}</p>
            </div>
            <div className="nav-right"></div>
          </div>
        );
        listAirline.push(buildAirline);
      }
      // Only Item Have Child Can Be Push
      if (item.length > 0) {
        const buildItemAccordion = (
          <div className="item" key={itemKey}>
            <div className="alphabet">
              <p>{itemKey}</p>
            </div>
            <div className="lists">{listAirline}</div>
          </div>
        );
        accordionItem.push(buildItemAccordion);
      }
    }
    if (accordionItem.length > 0) {
      return <div className="static-accordion">{accordionItem}</div>;
    }
    return (
      <div className="static-accordion">
        <div className="no-data">
          <p className="result-text">{formatMessage(text.searchRes)}</p>
          <img src={searchNotFound} className="nodata-images" alt="not found" />
          <div className="info-nodata">
            <h3 className="f-sans">{formatMessage(text.notFound)}</h3>
            <p>{formatMessage(text.notFoundDesc)}</p>
          </div>
        </div>
      </div>
    );
  }
}

StaticAccordion.displayName = config.displayName;
StaticAccordion.propTypes = config.propTypes;
StaticAccordion.defaultProps = config.defaultProps;

export default injectIntl(StaticAccordion);
